/** @type {import('../help-index.js').HelpSidebarItem} */
export const TAX_SUF_WITHHOLDINGS_ITEM = {
  id: 'suffered_withholdings',
  screenId: 'tax-suf-withholdings',
  label: 'Retenciones',
  description: 'Retenciones que te practicaron tus clientes al cobrar.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Consultás las retenciones de impuestos que tus clientes te descontaron al pagarte (registradas en los cobros). Útil para crédito fiscal y DDJJ.',
      },
      {
        title: 'Paso 1 — Filtrar',
        fields: [
          { label: 'Impuesto', description: 'Todos o un impuesto de retención configurado.' },
          { label: 'Desde / Hasta', description: 'Fecha de la retención. Tocá «Buscar» (por defecto, mes en curso).' },
        ],
      },
      {
        title: 'Paso 2 — Leer la lista',
        bullets: [
          'Columnas: Fecha ret., Cliente, Impuesto, Certificado, Alícuota, Base, Importe, Moneda, Recibo cobro.',
          'Solo lectura; los datos vienen de los cobros con retención. Exportable.',
        ],
      },
    ],
  },
}
